import React, { type ComponentType } from 'react';
import GenericQueryParamAdapter from '@atlassian/jira-common-query-param-adapter';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import IssueTypeSchemesAsync from './async';
import { SOURCE_NAME, defaultIssueTypeSchemesFilter, PACKAGE_NAME } from './constants';
import { METRICS_PAGE_ID, issueTypeSchemePageLoad } from './utils/performance-analytics';
import { fromUrlTransformer, toUrlTransformer } from './utils/transformers';

type Props = RouteContext;
const IssueTypeSchemesWithQueryParamAdapter = (props: Props) => (
	<GenericQueryParamAdapter
		location={props.location}
		queryFromUrl={fromUrlTransformer}
		queryToUrl={toUrlTransformer}
		defaultQuery={defaultIssueTypeSchemesFilter}
	>
		{({ query, onQueryChanged }) => (
			<IssueTypeSchemesAsync filter={query} onFilterChange={onQueryChanged} />
		)}
	</GenericQueryParamAdapter>
);
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RouterWrapper: ComponentType<Record<any, any>> = withRouter(
	IssueTypeSchemesWithQueryParamAdapter,
);

export const IssueTypeSchemesDirectory = () => (
	<>
		<MarkProductStart />
		<JSErrorBoundary
			id="issueTypeSchemesDirectory"
			packageName={PACKAGE_NAME}
			teamName="morphinecake"
			sendToPrivacyUnsafeSplunk
		>
			<ContextualAnalyticsData sourceName={SOURCE_NAME} sourceType={SCREEN}>
				<RouterWrapper />
				<SpaStatePageReady />
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex appName={METRICS_PAGE_ID} metric={issueTypeSchemePageLoad} />
				<FireScreenAnalytics />
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	</>
);
